import pick from 'lodash/pick';
import { useCallback, useState } from 'react';
import { useRecordContext } from 'react-admin';

const useEditableField = ({
  source,
}: {
  source: string;
}) => {
  const [editable, setEditable] = useState(false);
  const record = useRecordContext();
  const defaultValues = pick(record, source);

  const updateEditable = useCallback(() => {
    setEditable((prevEditable) => !prevEditable);
  }, []);

  const onSuccess = useCallback(() => {
    setEditable(false);
  }, []);

  return {
    editable,
    updateEditable,
    defaultValues,
    onSuccess,
  };
};

export default useEditableField;
